<template>
  <div class="p-grid p-fluid" style="padding-bottom: 2%;">        
        <Rotulo nome="Nome:" cols="12" >
            <InputText type="text" v-model="registro.nomePerfilAcesso"  placeholder="Nome"   />
        </Rotulo>
        <Rotulo nome="Nivel de Acesso:" cols="12 6" >
            <Dropdown 
              v-model="registro.nivelAcesso" 
              :options="nivelAcesso" 
              optionLabel="name" 
              optionValue="code"
              placeholder="Selecione um Nivel de Acesso" 
            />
        </Rotulo> 
        <Rotulo nome="Filtro Visualizacao:" cols="12 6" >
            <Dropdown 
              v-model="registro.filtroVisualizacao" 
              :options="filtroVisualizacao" 
              optionLabel="name" 
              optionValue="code"
              placeholder="Selecione um Filtro Visualizacao" 
            />
        </Rotulo> 
    </div> 
</template>


<script>
import Rotulo from '@/template/RotuloSeplag.vue'

export default {
  components: { Rotulo},
  props:{
    registro:{
      type:Object,
      required: true
    }
  },
  data:function(){
    return{
       nivelAcesso: [
                {
                    name: "Administrador do Sistema",
                    code: "SISTEMA"
                },
                {
                    name: "Administrador Setorial",
                    code: "SETORIAL"
                },
                {
                    name: "Operador do Sistema",
                    code: "OPERADOR"
                }
            ],
      filtroVisualizacao:[
              {
                  name:"Todos",
                  code: "TODOS"
              },
              {
                  name:"Somente o Setor de Lotação",
                  code: "SETOR"
              },
              {
                  name:"Somente os registros cadastrados",
                  code: "CADASTRO"
              }
          ]
    }
  },
  methods:{
    carregarDados(){
    }
  },
  mounted(){
    this.carregarDados()
  }
}
</script>